
import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

interface ProfileHeaderProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

const ProfileHeader = ({ activeTab, setActiveTab }: ProfileHeaderProps) => {
  return (
    <TabsList className="w-full overflow-x-auto flex items-center justify-start">
      <TabsTrigger value="profile">Profile</TabsTrigger>
      <TabsTrigger value="password">Password</TabsTrigger>
      <TabsTrigger value="notifications">Notifications</TabsTrigger>
    </TabsList>
  );
};

export default ProfileHeader;
